import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { colors, screenLayout, headingStyle, promptStyle } from '../styles/shared.js';
import { t } from '../i18n.js';
import { cmdProceed } from '../commands.js';

@customElement('locked-screen')
export class LockedScreen extends LitElement {
  static styles = [
    colors,
    screenLayout,
    headingStyle,
    promptStyle,
    css`
      :host {
        background: var(--color-bg-overlay);
      }
      .message {
        color: var(--color-cyan);
        font-size: 1.15rem;
      }
    `,
  ];

  render() {
    return html`
      <div></div>
      <div>
        <div class="heading">${t('locked-heading')}</div>
        <div class="message" style="margin-top: 1.5rem">${t('locked-message')}</div>
      </div>
      <div class="prompt" @click=${cmdProceed}>${t('locked-prompt')}</div>
    `;
  }
}
